import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.section`
	border-bottom: 1px solid ${helpers.color.separator};

	&:last-child {
		border-bottom: none;
	}
`
